"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
function NegativeResult(props) {
    return (React.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16" }, props),
        React.createElement("title", null, "Group"),
        React.createElement("g", { fill: "#02A77F", fillRule: "evenodd" },
            React.createElement("path", { d: "M8 14.776v.47A7.254 7.254 0 01.753 8C.753 4.004 4.003.753 8 .753c3.996 0 7.247 3.25 7.247 7.247A7.254 7.254 0 018 15.247v-.47zm0 0v-.47A6.313 6.313 0 0014.306 8 6.313 6.313 0 008 1.694 6.313 6.313 0 001.694 8 6.313 6.313 0 008 14.306v.47zM8 .471v.47A7.059 7.059 0 108 15.06 7.059 7.059 0 008 .941v-.47zm0 0V0a8 8 0 110 16A8 8 0 018 0v.47z", fillRule: "nonzero" }),
            React.createElement("path", { d: "M7.23 7.23H4v1.538h8V7.23H8.77z" }))));
}
exports.default = NegativeResult;
//# sourceMappingURL=NegativeResult.js.map